module.exports = __webpack_public_path__ + "Server-Unknown.Kubernetes.1cbff4adbe64421d528be102a156fd58.hashedasset.svg";